export const API_ENDPOINTS = {
    REGISTER: '/auth/register',
    VERIFY: '/auth/verify',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    PASSWORD: '/auth/password',
    REFRESH: '/auth/refresh',
    KYC: '/auth/kyc',
    RESEND: '/auth/resend',
    MARKET: '/markets',
    PRODUCT: '/products',
    ORDER: '/orders',
    GOLD_BOX: '/goldbox',
    PROFILE: '/users/profile',
    // Admin Endpoints
    ADMIN_MARKET:'/admin/markets',
    ADMIN_MARKET_PRODUCT:'/admin/markets/product',
    ADMIN_ORDERS:'/admin/orders',
    ADMIN_USERS:'/admin/users',
    ADMIN_GOLD_BOX: '/admin/goldbox',
};